import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ClipboardListIcon, TruckIcon, FlowerIcon, RefreshCwIcon, CalendarIcon, HeartIcon, PhoneIcon, CreditCardIcon, CheckCircleIcon, SettingsIcon } from 'lucide-react';
export function HowItWorksPage() {
  return <div className="min-h-screen flex flex-col" data-id="element-765">
      <Header data-id="element-766" />
      <main className="flex-grow" data-id="element-767">
        {/* Hero section */}
        <section className="bg-pink-700 text-white py-16" data-id="element-768">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-769">
            <div className="text-center" data-id="element-770">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-771">
                How Sunton Florist Works
              </h1>
              <p className="text-xl md:text-2xl text-pink-100 max-w-3xl mx-auto" data-id="element-772">
                We've reimagined flower delivery to make beautiful blooms a
                regular part of your life
              </p>
            </div>
          </div>
        </section>
        {/* Main process section */}
        <section className="py-16 bg-white" data-id="element-773">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-774">
            <div className="text-center mb-16" data-id="element-775">
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-776">
                Our Simple 4-Step Process
              </h2>
              <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-777">
                Getting started with Sunton Florist is easy and takes just a few
                minutes
              </p>
            </div>
            <div className="relative" data-id="element-778">
              {/* Connecting line */}
              <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-pink-100 -translate-y-1/2 z-0" data-id="element-779"></div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-8 relative z-10" data-id="element-780">
                <div className="bg-white rounded-lg p-8 shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-781">
                  <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-782">
                    <ClipboardListIcon className="h-8 w-8 text-pink-700" data-id="element-783" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center" data-id="element-784">
                    1. Choose Your Plan
                  </h3>
                  <p className="text-gray-600" data-id="element-785">
                    Select from our weekly, bi-weekly, or monthly subscription
                    options based on your needs. We offer various sizes and
                    price points to fit any budget.
                  </p>
                </div>
                <div className="bg-white rounded-lg p-8 shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-786">
                  <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-787">
                    <FlowerIcon className="h-8 w-8 text-pink-700" data-id="element-788" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center" data-id="element-789">
                    2. Customize Your Blooms
                  </h3>
                  <p className="text-gray-600" data-id="element-790">
                    Tell us your preferences for flower types, colors, and
                    styles. Add special notes for recipients if the flowers are
                    gifts. Personalize every delivery.
                  </p>
                </div>
                <div className="bg-white rounded-lg p-8 shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-791">
                  <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-792">
                    <TruckIcon className="h-8 w-8 text-pink-700" data-id="element-793" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center" data-id="element-794">
                    3. We Deliver
                  </h3>
                  <p className="text-gray-600" data-id="element-795">
                    Our team of expert florists carefully selects and arranges
                    your flowers, then delivers them right to your doorstep on
                    your scheduled delivery day.
                  </p>
                </div>
                <div className="bg-white rounded-lg p-8 shadow-md border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-796">
                  <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-797">
                    <RefreshCwIcon className="h-8 w-8 text-pink-700" data-id="element-798" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center" data-id="element-799">
                    4. Enjoy & Repeat
                  </h3>
                  <p className="text-gray-600" data-id="element-800">
                    Enjoy your beautiful fresh flowers, and we'll automatically
                    prepare and deliver your next arrangement according to your
                    subscription schedule.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Key features section */}
        <section className="py-16 bg-gray-50" data-id="element-801">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-802">
            <div className="text-center mb-16" data-id="element-803">
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-804">
                Key Features of Our Service
              </h2>
              <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-805">
                What makes Sunton Florist different from traditional flower
                delivery
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-806">
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-807">
                <div className="flex items-start" data-id="element-808">
                  <div className="flex-shrink-0 mr-4" data-id="element-809">
                    <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-810">
                      <CalendarIcon className="h-6 w-6 text-pink-700" data-id="element-811" />
                    </div>
                  </div>
                  <div data-id="element-812">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-813">
                      Flexible Scheduling
                    </h3>
                    <p className="text-gray-600" data-id="element-814">
                      Choose your delivery frequency and easily adjust delivery
                      dates through your account dashboard.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-815">
                <div className="flex items-start" data-id="element-816">
                  <div className="flex-shrink-0 mr-4" data-id="element-817">
                    <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-818">
                      <HeartIcon className="h-6 w-6 text-pink-700" data-id="element-819" />
                    </div>
                  </div>
                  <div data-id="element-820">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-821">
                      Personalized Selections
                    </h3>
                    <p className="text-gray-600" data-id="element-822">
                      Our system learns your preferences over time to create
                      arrangements that match your style perfectly.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-823">
                <div className="flex items-start" data-id="element-824">
                  <div className="flex-shrink-0 mr-4" data-id="element-825">
                    <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-826">
                      <PhoneIcon className="h-6 w-6 text-pink-700" data-id="element-827" />
                    </div>
                  </div>
                  <div data-id="element-828">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-829">
                      Delivery Notifications
                    </h3>
                    <p className="text-gray-600" data-id="element-830">
                      Receive SMS or email updates about your delivery status so
                      you always know when to expect your flowers.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-831">
                <div className="flex items-start" data-id="element-832">
                  <div className="flex-shrink-0 mr-4" data-id="element-833">
                    <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-834">
                      <CreditCardIcon className="h-6 w-6 text-pink-700" data-id="element-835" />
                    </div>
                  </div>
                  <div data-id="element-836">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-837">
                      Easy Payment
                    </h3>
                    <p className="text-gray-600" data-id="element-838">
                      Secure automatic billing with M-PESA, credit cards, or
                      bank transfers for hassle-free service.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-839">
                <div className="flex items-start" data-id="element-840">
                  <div className="flex-shrink-0 mr-4" data-id="element-841">
                    <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-842">
                      <CheckCircleIcon className="h-6 w-6 text-pink-700" data-id="element-843" />
                    </div>
                  </div>
                  <div data-id="element-844">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-845">
                      Freshness Guarantee
                    </h3>
                    <p className="text-gray-600" data-id="element-846">
                      All flowers come with our 7-day freshness guarantee or
                      we'll replace your arrangement at no cost.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-847">
                <div className="flex items-start" data-id="element-848">
                  <div className="flex-shrink-0 mr-4" data-id="element-849">
                    <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center" data-id="element-850">
                      <SettingsIcon className="h-6 w-6 text-pink-700" data-id="element-851" />
                    </div>
                  </div>
                  <div data-id="element-852">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-853">
                      Account Management
                    </h3>
                    <p className="text-gray-600" data-id="element-854">
                      Easily pause, skip, or modify your subscription anytime
                      through our user-friendly dashboard.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Testimonials */}
        <section className="py-16 bg-white" data-id="element-855">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-856">
            <div className="text-center mb-16" data-id="element-857">
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-858">
                What Our Customers Say
              </h2>
              <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-859">
                Join hundreds of satisfied customers who enjoy regular flower
                deliveries
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-860">
              <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-861">
                <div className="flex items-center mb-4" data-id="element-862">
                  <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=60&q=80" alt="Customer" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-863" />
                  <div data-id="element-864">
                    <h4 className="font-semibold text-gray-900" data-id="element-865">Sarah M.</h4>
                    <p className="text-sm text-gray-500" data-id="element-866">Nairobi, Kenya</p>
                  </div>
                </div>
                <p className="text-gray-600 italic" data-id="element-867">
                  "I've been a subscriber for 6 months now and the quality of
                  flowers is consistently excellent. The arrangements always
                  look fresh and last for well over a week. The subscription has
                  made my home feel more vibrant and welcoming."
                </p>
                <div className="mt-4 text-yellow-400" data-id="element-868">★★★★★</div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-869">
                <div className="flex items-center mb-4" data-id="element-870">
                  <img src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=60&q=80" alt="Customer" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-871" />
                  <div data-id="element-872">
                    <h4 className="font-semibold text-gray-900" data-id="element-873">David K.</h4>
                    <p className="text-sm text-gray-500" data-id="element-874">Mombasa, Kenya</p>
                  </div>
                </div>
                <p className="text-gray-600 italic" data-id="element-875">
                  "The subscription has been a game-changer for my office. Our
                  clients always comment on the beautiful arrangements, and it's
                  so convenient to have them delivered regularly without having
                  to remember to order."
                </p>
                <div className="mt-4 text-yellow-400" data-id="element-876">★★★★★</div>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-877">
                <div className="flex items-center mb-4" data-id="element-878">
                  <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=crop&w=60&q=80" alt="Customer" className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-879" />
                  <div data-id="element-880">
                    <h4 className="font-semibold text-gray-900" data-id="element-881">Amina J.</h4>
                    <p className="text-sm text-gray-500" data-id="element-882">Kisumu, Kenya</p>
                  </div>
                </div>
                <p className="text-gray-600 italic" data-id="element-883">
                  "I love the flexibility of the service. I was able to pause my
                  subscription when I went on vacation and resume it when I
                  returned. The customer service team is responsive and helpful.
                  Highly recommend!"
                </p>
                <div className="mt-4 text-yellow-400" data-id="element-884">★★★★★</div>
              </div>
            </div>
          </div>
        </section>
        {/* CTA section */}
        <section className="py-16 bg-pink-700 text-white" data-id="element-885">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-886">
            <h2 className="text-3xl font-bold mb-6" data-id="element-887">Ready to Get Started?</h2>
            <p className="text-xl text-pink-100 max-w-3xl mx-auto mb-8" data-id="element-888">
              Join Sunton Florist today and start enjoying regular deliveries of
              beautiful, fresh flowers
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-889">
              <Link to="/shop" className="px-8 py-3 bg-white text-pink-700 rounded-md text-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-890">
                Browse Our Shop
              </Link>
              <Link to="/signup" className="px-8 py-3 bg-pink-800 text-white rounded-md text-lg font-medium hover:bg-pink-900 transition-colors" data-id="element-891">
                Start Your Subscription
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-892" />
    </div>;
}